import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from "react-helmet-async";

export default function Gmflatinamerica() {
  return (
    <>
        <Helmet>
            <title>GMF Latin America | Gandhi Mandela Foundation</title>
            <meta name="description" content="GMF Latin America" />
            <link rel="canonical" href="/gmflatinamerica" />
        </Helmet>
        <Header/>
            <section className="page-header">
                <div className="container">
                <div className="breadcrumb">
                    <a href="/">Home</a>
                    <span>/</span>
                    <span>GMF Latin America</span>
                </div>
                <h1>GMF Latin America</h1>
                </div>
            </section>
            <section className="jury-members">
            <div className="container">
                <div className="members-grid">
                    <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Stephen-Murray.jpg" alt="STEPHEN MURRAY" />
                    </div>
                    <h3>STEPHEN MURRAY</h3>
                    <span>(President, Latin America)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Cathy-Barrow.jpg" alt="Cathy Barrow" />
                    </div>
                    <h3>Cathy Barrow</h3>
                    <span>(Vice-President, Latin America)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Juan-Pablo-Marroquin.jpg" alt="JUAN PABLO MARROQUIN" />
                    </div>
                    <h3>JUAN PABLO MARROQUIN</h3>
                    <span>(Secretary and Head of Public Relations, Latin America)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Italia-Almeida-Paredes.jpg" alt="Italia Almeida Paredes" />
                    </div>
                    <h3>Italia Almeida Paredes</h3>
                    <span>(Treasurer, Latin America)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Alfredo-Rocha-Avila.jpg" alt="ALFREDO ROCHA AVILA" />
                    </div>
                    <h3>ALFREDO ROCHA AVILA</h3>
                    <span>(Vice-President, Bolivia)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Patria-Fernandez-Veras.jpg" alt="Patria Fernandez Veras" />
                    </div>
                    <h3>Patria Fernandez Veras</h3>
                    <span>(Vice President, Caribbean)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Pedro-Musa-Velazquez.jpg" alt="Pedro Musa Velazquez" />
                    </div>
                    <h3>Pedro Musa Velazquez</h3>
                    <span>(Vice-President, Dominican Republic)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Mauricio-Gomez.jpg" alt="Mauricio Gomez" />
                    </div>
                    <h3>Mauricio Gomez</h3>
                    <span>(Vice-President, Colombia)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Neslin-Arce-Mendizabal.jpg" alt="Neslin Arce Mendizabal" />
                    </div>
                    <h3>Neslin Arce Mendizabal</h3>
                    <span>(Vice-President, Panama)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Otto-von-Feigenblatt.jpg" alt="Otto von Feigenblatt" />
                    </div>
                    <h3>Otto von Feigenblatt</h3>
                    <span>(Vice-President, Education and Development)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Vandre-Brilhante.jpg" alt="Vandre Brilhante" />
                    </div>
                    <h3>Vandre Brilhante</h3>
                    <span>(Vice-President, Brazil)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Ana-Mendieta.jpg" alt="Ana Mendieta" />
                    </div>
                    <h3>Ana Mendieta</h3>
                    <span>(Vice-President, Argentina)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Barbara-Llanes.jpg" alt="Barbara Llanes" />
                    </div>
                    <h3>Barbara Llanes</h3>
                    <span>(Vice-President, Cuba)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Martha-Cecilia-Diaz-Gordillo.jpg" alt="Martha Cecilia Diaz Gordillo" />
                    </div>
                    <h3>Martha Cecilia Diaz Gordillo</h3>
                    <span>(Vice-President for Indigenous Peoples)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Teresita-Irujari-Novela.jpg" alt="Teresita Irujari Novela" />
                    </div>
                    <h3>Teresita Irujari Novela</h3>
                    <span>(Vice-President for Social Service and Education)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Celia-Maxwell-Haywood.jpg" alt="Celia Maxwell Haywood" />
                    </div>
                    <h3>Celia Maxwell Haywood</h3>
                    <span>(Vice President for Venezuela)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Sandra-Arce-Ramos.jpg" alt="Sandra Arce Ramos" />
                    </div>
                    <h3>Sandra Arce Ramos</h3>
                    <span>(Vice President for Costa Rica)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Efrain-Chi-Pool.jpg" alt="Efrain Chi Pool" />
                    </div>
                    <h3>Efrain Chi Pool</h3>
                    <span>(Vice President for Education and Peace)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Anita-Menchu-Tum.jpg" alt="Anita Menchu Tum" />
                    </div>
                    <h3>Anita Menchu Tum</h3>
                    <span>(Vice President for Indigenous Peoples)</span>
                </div>
                <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Juan-Pablo-Quintana.jpg" alt="Juan Pablo Quintana" />
                    </div>
                    <h3>Juan Pablo Quintana</h3>
                    <span>(Vice President Entrepreneurial Affairs)</span>
                </div>
            </div>
            </div>
        </section>
            {/* =========================
            FOOTER
            ========================== */}
        <Footer/>
        </>
  )
}
